import { addHours } from 'date-fns';

function checkIsLive(item) {
  const date = new Date(item.date),
    notLiveAfter = addHours(new Date(item.date), 5);

  return new Date() > date && new Date() < notLiveAfter && !item.score?.length;
}

export default checkIsLive;
